import {
  Button,
  Input,
  Label,
  Select,
  Toaster,
} from "@fluentui/react-components";
import React, { ChangeEvent, useEffect, useId, useState } from "react";
import TextEditor from "../../../components/TextEditor";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import OverlayLoader from "../../../components/OverlayLoader";
import {
  convertStringToArray,
  getReceiptStatus,
  stripHtml,
} from "../../../utils";
import ASCButton from "../../../components/Button";
import { useToastMessage } from "../../../components/ToastMessage/ToastMessage";
import apiServices from "../../../service";
import { updateCommission } from "../../../redux/Commission/commissionSlice";

const CommissionForm = (props: any) => {
  const selectId = useId();
  const { showToast, toasterId } = useToastMessage();
  const dispatch: AppDispatch = useDispatch();

  const data = useSelector((state: RootState) => state.commission.filteredData);
  const loading = useSelector(
    (state: RootState) => state.commission.loading.updateCommission
  );
  const error = useSelector(
    (state: RootState) => state.commission.error.updateCommission
  );

  const [formField, setFormField] = useState({
    ...data,
    commission_status: data.commission_status || "0",
    commission_startDate: data.commission_startDate || "",
    commission_endDate: data.commission_endDate || "",
    commission_note: data.commission_note || "",
  });
  const [selectFieldOptions, setSelectFieldOptions] = useState<any>([]);

  const onFormatDate = (date?: Date): string => {
    return date ? moment(date).format("DD-MM-YYYY") : "";
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormField({ ...formField, [e.target.name]: e.target.value });
  };

  const getSelectionListOptions = async () => {
    try {
      const fieldLbl =
        "commission_type:MasterDatawithoutNewEntry,payment_source:FixedList,frequency:FixedList,true_false:FixedList";
      const res = await apiServices.selectionList.getOptions(fieldLbl);
      if (res.data && res.data.data) {
        setSelectFieldOptions(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getSelectionListOptions();
  }, []);

  useEffect(() => {
    if (error) {
      showToast(error, "", "error");
    }
  }, [error, showToast]);

  const handleUpdateCommission = () => {
    const formattedFormData: any = {
      type: formField.type,
      customer_id: formField.customer_id,
      case_id: formField.case_id,
      payment_id: formField.payment_id,
      status: formField.status,
      commission_type: formField.commission_type,
      payment_source: formField.payment_source,
      actual: formField.actual || "0.00",
      commission_frequency: formField.commission_frequency,
      commission_startDate: formField.commission_startDate
        ? moment(formField.commission_startDate).utc()
        : "",
      commission_endDate: formField.commission_endDate
        ? moment(formField.commission_endDate).utc()
        : "",
      payment_count: parseInt(formField.payment_count) || 0,
      nb_register: formField.nb_register || 0,
      commission_note: formField.commission_note || "",
    };

    dispatch(
      updateCommission({
        commissionId: formField.commission_id,
        formData: formattedFormData,
      })
    ).then((result: any) => {
      if (updateCommission.fulfilled.match(result)) {
        props.getReceiptlistData();
        showToast(
          result.payload?.message || "Commission updated successfully",
          "",
          "success"
        );
        setTimeout(() => {
          props.setReceiptEditpopup(false);
        }, 3000);
      }
    });
  };

  return (
    <div>
      <OverlayLoader isLoading={loading} />
      <Toaster
        toasterId={toasterId}
        position="top-end"
        pauseOnHover
        pauseOnWindowBlur
        timeout={1000}
      />
      <div className="commission_action_main">
        <div className="settings-table-content-label">Status</div>
        <span>{getReceiptStatus(formField.commission_status)}</span>
        <div className="settings-table-content-label">Commission type</div>
        <Select
          id={selectId}
          name="commission_type"
          value={formField.commission_type || ""}
          onChange={(e) =>
            setFormField({ ...formField, commission_type: e.target.value })
          }
        >
          {selectFieldOptions
            .find((option: any) => option.field === "commission_type")
            ?.options.map((opt: { value: string; label: string }) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
        </Select>
        <div className="settings-table-content-label">Source of Payment</div>
        <Select
          id={selectId}
          name="payment_source"
          value={formField.payment_source || ""}
          onChange={(e) =>
            setFormField({ ...formField, payment_source: e.target.value })
          }
        >
          {selectFieldOptions
            .find((option: any) => option.field === "payment_source")
            ?.options.map((opt: { value: string; label: string }) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
        </Select>
        <Label className="settings-table-content-label">
          Amount to Company
        </Label>
        <Input
          onChange={onChange}
          name="actual"
          disabled={formField.commission_status !== "0"}
          value={formField.actual || ""}
        />
        <Label className="settings-table-content-label">Frequency</Label>
        <Select
          id={selectId}
          name="frequency"
          disabled={formField.commission_status !== "0"}
          value={formField.frequency || formField.commission_frequency || ""}
          onChange={(e) =>
            setFormField({ ...formField, frequency: e.target.value })
          }
        >
          {selectFieldOptions
            .find((item: any) => item.field === "frequency")
            ?.options.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </Select>
        <Label className="settings-table-content-label">
          Commission Start Date
        </Label>
        <DatePicker
          placeholder="Select date"
          allowTextInput
          disabled={formField.commission_status !== "0"}
          formatDate={onFormatDate}
          value={
            formField.commission_startDate
              ? new Date(formField.commission_startDate)
              : null
          }
          onSelectDate={(date) =>
            setFormField({
              ...formField,
              commission_startDate: date
                ? moment(date).format("DD-MM-YYYY")
                : "",
            })
          }
        />
        <Label className="settings-table-content-label">End Date</Label>
        <DatePicker
          placeholder="Select date"
          allowTextInput
          disabled={formField.commission_status !== "0"}
          formatDate={onFormatDate}
          value={
            formField.commission_endDate
              ? new Date(formField.commission_endDate)
              : null
          }
          onSelectDate={(date) =>
            setFormField({
              ...formField,
              commission_endDate: date ? moment(date).format("DD-MM-YYYY") : "",
            })
          }
        />
        <Label className="settings-table-content-label">
          Number of Payment
        </Label>
        <Input
          onChange={onChange}
          name="payment_count"
          disabled={formField.commission_status !== "0"}
          value={formField.payment_count || ""}
        />
        <Label className="settings-table-content-label">
          Show AMT on NB Register
        </Label>
        <Select
          id={selectId}
          name="nb_register"
          value={formField.nb_register || ""}
          onChange={(e) =>
            setFormField({ ...formField, nb_register: e.target.value })
          }
        >
          {selectFieldOptions
            .find((item: any) => item.field === "true_false")
            ?.options.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </Select>
        <Label className="settings-table-content-label">Note</Label>
        <TextEditor
          inputData={formField.commission_note}
          onChange={(text: string) => {
            const cleanedText = stripHtml(text).trim();
            const sanitizedText =
              /^(<p>\s*<br>\s*<\/p>|\s*)$/i.test(text.trim()) ||
              cleanedText === ""
                ? ""
                : text;
            setFormField({ ...formField, commission_note: sanitizedText });
          }}
        />
      </div>
      <div className="button-end-popup">
        {!convertStringToArray(process.env.REACT_APP_HIDE_CTA_BUTTON).includes(
          "hide_cm_receipting_stop_receipts"
        ) && (
          <Button
            shape="rounded"
            onClick={() => props.setStopReceiptpopup(true)}
            disabled={
              formField.commission_status !== "1" ||
              !convertStringToArray(
                process.env.REACT_APP_DISABLE_CTA_BUTTON
              ).includes("disable_cm_receipting_stop_receipts")
                ? false
                : true
            }
          >
            Stop Receipts
          </Button>
        )}
        <Button
          shape="rounded"
          className="asc-button-primary"
          appearance="primary"
          type="submit"
          size="medium"
          style={{ marginRight: 6 }}
          onClick={handleUpdateCommission}
          disabled={loading}
        >
          Save
        </Button>
        <Button
          shape="rounded"
          appearance="secondary"
          type="submit"
          size="medium"
          onClick={() => props.setReceiptEditpopup(false)}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default CommissionForm;
